































const QING_URL_1 = 'http://fx-ygyl.pek3a.qingstor.com'
const QING_URL_2 = 'https://fx-ygyl.pek3a.qingstor.com'
const ALIYUN_URL = 'https://fxscms.oss-cn-beijing.aliyuncs.com'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
@Component
export default class UploadImg extends Vue {
	@Prop({
		type: Array,
		required: false,
		default: () => {
			return []
		}
	})
	private fileList: any
	@Prop({
		type: Number,
		required: false,
		default: 1
	})
	private maxSize?: number
	@Prop({
		type: Boolean,
		required: false,
		default: false
	})
	private disabled?: boolean
	@Prop({
		type: Boolean,
		required: true,
		default: false
	})
	private addState?: boolean
	private dialogImgVisible: boolean = false
	private imgIndex: number = 0
	private imgActiveIndex: number = -1
	private onImgClick (item: any, index: number) {
		// this.imgIndex = index
		// this.dialogImgVisible = true
		// this.$nextTick(() => {
		// 	(this as any).$refs.carousel.setActiveItem(index)
		// })
		const img = new Image()
		const newWin = window.open('', '_blank')
		img.src = (this as any).$fxCommon.urlQingstorToAliyuncs(item.path)
		img.onerror = () => { this.imgErrorHandler(newWin, img.src) }
		if (newWin) {
			newWin.document.write(img.outerHTML)
			newWin.document.title = ''
			newWin.document.close()
		}
	}
	private imgErrorHandler (newWin, path) {
		let tryUrl = path
		if (tryUrl.indexOf(QING_URL_1) === 0) {
			tryUrl = ALIYUN_URL + tryUrl.substr(QING_URL_1.length)
		} else if (tryUrl.indexOf(QING_URL_2) === 0) {
			tryUrl = ALIYUN_URL + tryUrl.substr(QING_URL_2.length)
		}
		const img = new Image()
		img.src = tryUrl
		if (newWin) {
			newWin.document.write(img.outerHTML)
			newWin.document.close()
		}
	}
	private onImgChange (event: any) {
		const file = (this as any).$refs.uploadFile.files[0]
		if (file.size > (this as any).maxSize * 1024 * 1024) {
			(this as any).$fxMessage.warning(`文件大小不能超过${this.maxSize}MB`)
			return false
		}
		(this as any).$refs.uploadFile.value = ''
		this.readFile(file, (e) => {
			this['on-image-upload']({uploadFile: file, event: e})
		})
	}
	@Emit()
	private 'on-image-upload' (file: any) {
		return file
	}
	private readFile (file?: any, func?: any) {
		const reader = new FileReader()
		reader.onload = func
		reader.readAsDataURL(file)
	}
	private onAddClick () {
		(this as any).$refs.uploadFile.click()
	}
}
